import { FILA_CHAVES_SET_CHAVES_FAIL, FILA_CHAVES_SET_CHAVES_SUCCESS } from '../actions/types';

const INITIAL_STATE = {
  filaChavesNFe: [],
  filaChavesCTe: [],
  erro: false,
};

export default (state = INITIAL_STATE, action) => {
  const { type, payload } = action;

  switch (type) {
    case FILA_CHAVES_SET_CHAVES_SUCCESS:
      return {
        ...state,
        filaChavesNFe: payload.nfe || state.filaChavesNFe,
        filaChavesCTe: payload.cte || state.filaChavesCTe,
        erro: false,
      };
    case FILA_CHAVES_SET_CHAVES_FAIL:
      return { 
        ...state, 
        erro: true 
      };
    default:
      return state;
  }
};
